import { extractProblemDetails } from "@presentation/common/ErrorHelpers";

const MANAGER_INVARIANT_TITLE_SUFFIXES = ["LastManagerCannotBeDemoted", "LastManagerCannotBeRemoved"];

/**
 * Matches the backend's manager invariant guard (rejecting a role change or removal that would
 * leave a team/project without a Manager), surfaced as a specific, actionable message instead of
 * a generic save-failed error. Returns `null` for any other error, including a 403 denial, which
 * `classifyDenial` already handles.
 */
export const describeManagerInvariantDenial = (error: unknown, scopeLabel: "team" | "project"): string | null => {
  const { title } = extractProblemDetails(error);
  const isManagerInvariantDenial = Boolean(title) && MANAGER_INVARIANT_TITLE_SUFFIXES.some((suffix) => title!.endsWith(suffix));
  return isManagerInvariantDenial ? `This ${scopeLabel} must always have a Manager - assign another Manager first.` : null;
};
